<template>
<div class="body">
  <q-card>
    <q-card-title>
      {{$t('global.EnterYield')}}
    </q-card-title>
    <div class="row">
      <div class="col-4 q-px-sm"><q-input v-model="quantity" :stack-label="$t('global.Quantity')" type="number" :decimals="2" /></div>
      <div v-if="false" class="col-4 q-px-sm"><q-input v-model="quality" :stack-label="$t('global.Quality')" type="number" :decimals="2" /></div>
      <div class="col q-px-sm"><q-datetime v-model="date" type="date" :float-label="$t('global.Date')" format="DD.MMM.YYYY"/></div>       
    </div>
     <div class="row">
       <div class="col q-px-sm"><q-input v-model="comment" rows="1" :float-label="$t('global.Comment')" type="textarea" /></div>  
     </div>  
    <div class="row">    
      <div class="col-6 q-px-sm"> 
        <q-select
          v-model="IdProduct"
          :float-label="$t('global.Product')"
          :options="optionsProduct"   
        />  
      </div>
      <div class="col-6 q-px-sm">
        <q-select
          multiple
          v-model="multipleSelect"
          :options="selectOptions"   
          :float-label="$t('global.SelectField')"
          :display-value="`${multipleSelect.length} ` + $t('global.Fields')"
        />
      </div>
    </div>
      <hr class="content">
      <div class="row">
        <div class="col-3 q-px-sm">    
         {{$t('global.Field')}}
        </div>
        <div class="col-3 q-px-sm number">    
           {{$t('global.Hectare')}}
        </div>
        <div class="col-3 q-px-sm number">    
          {{$t('global.Percent')}}
        </div>
        <div class="col-3 q-px-sm number">    
          {{$t('global.Quantity')}}
        </div>
      </div>
      <hr class="content">
      <div class="row" v-for="p in multipleSelect" :key="p">
        <div class="col-3 q-px-sm">    
         {{ geoRegion[p].Description }}
        </div>
        <div class="col-3 q-px-sm number">    
          {{ round(geoRegion[p].SquareMeter / 10000, 4) }}
        </div>
        <div class="col-3 q-px-sm number">    
          {{round((100 / totalHa) * (geoRegion[p].SquareMeter / 10000),0)}}
        </div>
        <div class="col-3 q-px-sm number" v-if="false">           
           {{round(quantity / 100 * (round((100 / totalHa) * (geoRegion[p].SquareMeter / 10000),0)),2)}}   
        </div>
        <div class="col-3 q-px-sm number" v-if="false">           
           <input type="number" :value="round(quantity / 100 * (round((100 / totalHa) * (geoRegion[p].SquareMeter / 10000),0)),2)" name="lastname"> 
        </div>
        <div class="col-3 q-px-sm number" v-if="true">           
           <input class="inp" type="number" :name="p" :ref="p" :value="round(quantity / 100 * (round((100 / totalHa) * (geoRegion[p].SquareMeter / 10000),0)),2)">
        </div>
      </div>
      <hr class="content">
      <div class="row">
        <div class="col-3 q-px-sm">    
         {{$t('global.Total')}}:
        </div>
        <div class="col-3 q-px-sm number">    
          {{round(totalHa, 4)}}
        </div>
        <div class="col-3 q-px-sm number">    
          100
        </div>
        <div class="col-3 q-px-sm number">       
        </div>
      </div>
      <hr class="content">
      <div class="row">
        <div class="col q-px-sm"></div>
        <div class="col q-px-sm confirm">
          <q-btn :disable="!quantity || multipleSelect.length == 0" size="sm" color="primary" v-on:click="sendRequest" >{{$t('global.Save')}}</q-btn>
        </div>
      </div>  
    </q-card>
    <YieldJournal></YieldJournal>
</div>

</template>

<script>
import axios from 'axios'
import qs from 'qs'

import {eventBus} from '../main'
import { date } from 'quasar'
import YieldJournal from '@/components/Yield/YieldJournal'

export default {
  name: 'EnterYield',
  data: function () {
    return {
      form: {
        SessionId: null,
      },
      selectOptions: [],
      multipleSelect: [],
      geoRegion: [],
      quantity: null,
      quality: null,
      comment: null,
      date: date.addToDate(Date.now(), { days: 0 }),
      IdProduct: null,
      optionsProduct: []
    }
  },
  components: {
    'YieldJournal': YieldJournal
  },
  methods: {

    loadFields(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GeoRegionsFieldByProduct"
      this.form.IdProduct = this.IdProduct
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              var totalSM = 0 
              this.selectOptions = [] 
              response.data.forEach(field => {
                this.selectOptions.push({value: field.IdGeoRegion, label: field.Description})
                this.geoRegion[field.IdGeoRegion] = field
              })
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
      
    },
    round(value, decimals) {
      return Number(Math.round(value+'e'+decimals)+'e-'+decimals)
    },
    
    sendRequest(){
      var update = {}
      update.geoRegion = []
      
      //update.quality = this.quality
      update.IdProduct = this.IdProduct
      update.date = this.date
      update.comment = this.comment

      for (var ref in this.$refs) {
        if(this.$refs[ref][0] != undefined){
          update.geoRegion.push({ IdGeoRegion: ref, quantity: this.$refs[ref][0].valueAsNumber })
        }
      }
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.update = update
      this.form.action = "insertYield"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
             this.$q.notify({ message: this.$t('global.HarvestReorded'), type: 'positive' })
             this.multipleSelect = []
             this.quantity = null
             this.quantity = null
             eventBus.$emit('yieldChange', null)
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },

    loadProduct(){
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "getProduct"
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            console.log(response)
            if(response.status == 200){ 
              this.optionsProduct = response.data
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {        
          this.$q.notify('Something Wrong.')      
          console.log(e);
        })
    },

  },
    watch: {
    selectedWork: function (val) {
      this.workEdit = this.workTreeFlat[val]
      this.editIdType = this.workEdit.IdType.toString()
    },
    IdProduct: function(val){
      this.loadFields()
    }
  },
  created () {
    this.loadProduct()
    eventBus.$on('dataChange', (data) => {
      this.loadProduct()
    })
  },
  computed: {
    totalHa: function () {  
        var total = 0.0    
        this.multipleSelect.forEach(p => {
          total += this.round(this.geoRegion[p].SquareMeter / 10000, 4)
      })
      return total
    },
  },
}
</script>
<style scoped>
.content{
  margin-left: 10px;
  margin-right: 10px;
}
.body{
  padding: 10px;
}
.number{
  text-align: right;
}
.inp{
  text-align: right;
  height: 20px;
  width: 60%;
}

.confirm{
  justify-content: right;
  padding-bottom: 10px;
}

</style>